var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, EventEmitter, HostListener } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { config } from '../../../../config/config';
import { HubFacebookFeedsCommand } from '../../../commands/hub/event/add.facebook.general.feed.command';
import { HubCalendarActionCommand } from '../../../commands/pagination.query.command';
import { AccordionComponent } from '../../../common/components/accordion/accordion.component';
import { BaseComponent } from '../../../common/components/base.component';
import { ImageService } from '../../../services/image.service';
import { PlaceService } from '../../../services/place.service';
import { VisitorDataCache, VisitorSettingsStore } from '../../../stores/visitor.calendar.store';
import { PDFSettingCommand } from '../export.pdf.modal/export.pdf.modal.provider';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { HubVisitorToggleDataSource } from '../../../models/hub/hub.visitor.feature.toggle';
import { CustomizationApiService } from '../../../services/customization.api.service';
import { CustomBtnStore, CustomDefaultPlaceCategoryStore, EditorChoiceStore, HubCalendarStore, HubFacebookLocationFeedsStore, HubFacebookPageFeedsStore, HubLogoStore, PDFSettingsStore, ToggleAndDataSourceStore, ToggleStore, ToursStore, } from '../../../stores/hub.calendar.store';
import { HubApiService } from '../../../services/hub.api.service';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { isEmptyObject } from '../../../common/extensions';
import { EditorChoiceDataSource } from '../../../models/hub/hub.event';
import { EventTimeService } from '../../../services/event.time.service';
import { CustomDefaultPlaceCategoryAccordionComponent } from '../custom.default.place.category.accordion/custom.default.place.category.accordion.component.';
import { KeywordService } from '../../../services/keyword.service';
var HubNavigatorComponent = /** @class */ (function (_super) {
    __extends(HubNavigatorComponent, _super);
    function HubNavigatorComponent(router, hubCalendarStore, formBuilder, hubFacebookPageFeedsStore, hubFacebookLocationFeedsStore, pdfSettingsStore, hubLogoStore, visitorSettingsCommand, togglesStore, toggleAndDataSourceStore, toursStore, customBtnStore, editorChoiceStore, customDefaultPlaceCategoryStore, activatedRoute, customizationService, hubApiService, imageService, KeywordService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.hubCalendarStore = hubCalendarStore;
        _this.formBuilder = formBuilder;
        _this.hubFacebookPageFeedsStore = hubFacebookPageFeedsStore;
        _this.hubFacebookLocationFeedsStore = hubFacebookLocationFeedsStore;
        _this.pdfSettingsStore = pdfSettingsStore;
        _this.hubLogoStore = hubLogoStore;
        _this.visitorSettingsCommand = visitorSettingsCommand;
        _this.togglesStore = togglesStore;
        _this.toggleAndDataSourceStore = toggleAndDataSourceStore;
        _this.toursStore = toursStore;
        _this.customBtnStore = customBtnStore;
        _this.editorChoiceStore = editorChoiceStore;
        _this.customDefaultPlaceCategoryStore = customDefaultPlaceCategoryStore;
        _this.activatedRoute = activatedRoute;
        _this.customizationService = customizationService;
        _this.hubApiService = hubApiService;
        _this.imageService = imageService;
        _this.KeywordService = KeywordService;
        _this.isFilterDateEnabled = false;
        _this.isLoadingFeeds = false;
        _this.eventStatusSelection = 'approved';
        _this.displayingOn = DisplayingOn.event;
        _this.command = new HubCalendarActionCommand();
        _this.today = new Date();
        _this.logoUrl = config.defaultLogoUrl;
        _this.logo = {
            isDefault: true,
            url: '',
        };
        _this.toggleAndSource = new HubVisitorToggleDataSource();
        _this.loadingToggles = true;
        _this.searchParam = {
            searchTimeout: null,
            debounceTime: 500,
            isSearching: false,
            searchText: '',
            isShowSearchPlaceWithNoFilter: false,
            isSearchPlaceWithNoFilter: false,
            isShowFuzzySearch: false,
            isFuzzySearch: true,
        };
        _this.customDefaultPlaceCategory = null;
        _this.isOpenRegionalAccountType = false;
        _this.isLoadingDMOs = false;
        _this.onClose = new EventEmitter();
        return _this;
    }
    HubNavigatorComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.searchFormGroup = this.formBuilder.group({
            searchText: [null],
        });
        this.loadingToggles = true;
        this.hubApiService.getAllSettings(this.hubName).subscribe(function (data) {
            console.log(data);
            localStorage.setItem(localStorageKeys.allBackendSettings, JSON.stringify(data));
            localStorage.setItem(localStorageKeys.timezoneFormatterDefault, data.customSettings.timezoneFormatter);
            if (data.toggle) {
                if (_this.isAllPlaceCategoriesTurnedOff) {
                    data.toggle.placeCalendar = false;
                }
                _this.toggleAndSource.toggle = data.toggle;
                _this.toggleAndSource.dataSource = data.dataSource;
                _this.togglesStore.toggleCommand.next(_this.toggleAndSource.toggle);
                _this.toggleAndSource.isKeepTempClosedPlaceInApproved = data.customSettings.isKeepTempClosedPlaceInApproved;
                _this.toggleAndDataSourceStore.toggleAndDataSourceCommand.next(_this.toggleAndSource);
                _this.isOpenRegionalAccountType = data.toggle.regionalAccountType;
            }
            _this.customDefaultPlaceCategory = data.customSettings.customDefaultPlaceCategory;
            console.log('sidebar customDefaultPlaceCategory', _this.customDefaultPlaceCategory);
            if (data.customSettings.customEditorChoice) {
                var editorChoice = new EditorChoiceDataSource();
                editorChoice.editorChoiceForEvent =
                    data.customSettings.customEditorChoice.editorChoiceForEvent || "EDITOR'S CHOICE";
                editorChoice.editorChoiceForPlace =
                    data.customSettings.customEditorChoice.editorChoiceForPlace || "EDITOR'S CHOICE";
                _this.editorChoiceStore.infoCommand.next(editorChoice);
            }
            _this.hubPages =
                data && data.pageFeeds
                    ? data.pageFeeds.filter(function (x) { return !config.placeSocialName.any(function (y) { return y === x.socialName; }); })
                    : [];
            _this.hubLocations = data && data.locationFeeds ? data.locationFeeds : [];
            // this.facebookLocations = this.hubLocations.filter(x => config.placeSocialName.any(y => y === x.socialName));
            _this.facebookLocations = _this.hubLocations.filter(function (x) { return x.socialName === (_this.toggleAndSource.dataSource.place || 'facebook'); });
            _this.otherLocations = _this.hubLocations.filter(function (x) { return !config.placeSocialName.any(function (y) { return y === x.socialName; }); });
            //this.eventFeeds = !this.toggleAndSource.toggle.eventByGeolocation ? this.hubPages : this.hubPages.concat(this.otherLocations as Array<any>);
            _this.hubPages.forEach(function (page) {
                page.displayTitle = page.title || '@' + page.name;
            });
            _this.otherLocations.forEach(function (location) {
                location.displayTitle = location.title + " - " + (location.socialName == 'eventful' ? 'Performers,Venues, Ticketing Websites' : location.socialName);
            });
            _this.facebookLocations.forEach(function (location) {
                location.displayTitle = location.title + " - " + location.socialName;
            });
            _this.eventFeeds = !_this.toggleAndSource.toggle.eventByGeolocation
                ? _this.hubPages
                : _this.hubPages.concat(_this.otherLocations);
            _this.hubFacebookPageFeedsStore.pagesCommand.next(new HubFacebookFeedsCommand(_this.eventFeeds));
            _this.hubFacebookLocationFeedsStore.locationCommand.next(new HubFacebookFeedsCommand(_this.facebookLocations));
            _this.logoUrl =
                isNullOrUndefined(data.logo) || isNullOrUndefined(data.logo.isDefault) || data.logo.isDefault
                    ? config.defaultLogoUrl
                    : data.logo.url;
            _this.logoUrl = _this.imageService.imageSourceUrl(_this.logoUrl);
            VisitorDataCache.logo = _this.logoUrl;
            VisitorDataCache.placeCategories = data.placeCategories;
            _this.hubLogoStore.logoCommand.next(data.logo);
            _this.visitorSettingsCommand.settingsCommand.next(data.customSettings);
            var pdfSettings = new PDFSettingCommand();
            pdfSettings.pdf = data.pdf;
            pdfSettings.eventCalendarURL = data.eventCalendarURL;
            pdfSettings.placeCalendarURL = data.placeCalendarURL;
            pdfSettings.moreToursURL = data.moreToursURL;
            _this.pdfSettingsStore.pdfCommand.next(pdfSettings);
            _this.toursStore.toursCommand.next(data.tours);
            _this.customBtnStore.customBtnCommand.next(data.customBtns);
            _this.loadingToggles = false;
            if (_this.activatedRoute.firstChild) {
                _this.activatedRoute.firstChild.url.subscribe(function (x) {
                    _this.command.isEventCalendar = x[0].path === routeConfigs.hub.eventCalendar.path;
                });
                _this.command.queryParams.source = _this.toggleAndSource.dataSource.place;
                _this.hubCalendarStore.actionCommand.next(_this.command);
            }
        });
        this.hubFacebookLocationFeedsStore.locationCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (hubLocations) {
            _this.hubLocations = hubLocations.hubPages;
            // this.facebookLocations = (this.hubLocations && this.hubLocations.length) ? this.hubLocations.filter(x => x.socialName === 'facebook') : [];
            _this.facebookLocations =
                _this.hubLocations && _this.hubLocations.length
                    ? _this.hubLocations.filter(function (x) {
                        return x.socialName ===
                            ((_this.toggleAndSource.dataSource && _this.toggleAndSource.dataSource.place) || 'facebook');
                    })
                    : [];
            // this.otherLocations = (this.hubLocations && this.hubLocations.length) ? this.hubLocations.filter(x => x.socialName !== 'facebook') : [];
            _this.otherLocations =
                _this.hubLocations && _this.hubLocations.length
                    ? _this.hubLocations.filter(function (x) { return !config.placeSocialName.any(function (y) { return y === x.socialName; }); })
                    : [];
        });
        this.hubFacebookPageFeedsStore.pagesCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (hubPages) {
            _this.hubPages =
                hubPages.hubPages && hubPages.hubPages.length
                    ? hubPages.hubPages.filter(function (x) { return x.socialName !== 'facebook'; })
                    : [];
        });
        this.hubLogoStore.logoCommand.takeUntil(this.isDestroyed).subscribe(function (logo) {
            _this.logoUrl =
                isNullOrUndefined(logo) || isNullOrUndefined(logo.isDefault) || logo.isDefault
                    ? config.defaultLogoUrl
                    : logo.url;
            _this.logoUrl = _this.imageService.imageSourceUrl(_this.logoUrl);
        });
        this.customDefaultPlaceCategoryStore.CustomDefaultPlaceCategoryCommand.takeUntil(this.isDestroyed).subscribe(function (category) {
            if (!isEmptyObject(category)) {
                _this.customDefaultPlaceCategory = category;
            }
        });
    };
    Object.defineProperty(HubNavigatorComponent.prototype, "isShowThingsToDo", {
        get: function () {
            return (!this.loadingToggles &&
                (this.toggleAndSource.toggle.placeCategory.activity ||
                    this.toggleAndSource.toggle.placeCategory.art ||
                    this.toggleAndSource.toggle.placeCategory.outdoor ||
                    this.toggleAndSource.toggle.placeCategory.entertainment));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HubNavigatorComponent.prototype, "isEventEnabled", {
        get: function () {
            return this.toggleAndSource.toggle.manualEvents || this.toggleAndSource.toggle.eventByGeolocation;
        },
        enumerable: true,
        configurable: true
    });
    HubNavigatorComponent.prototype.close = function () {
        this.onClose.emit();
    };
    HubNavigatorComponent.prototype.showFacebookEvents = function () {
        this.command.isEventCalendar = true;
        this.command.queryParams.category = 'All';
        this.command.queryParams.feedId = null;
        this.command.queryParams.isManuallyCreated = null;
        this.command.queryParams.isHubCreated = null;
        this.hubCalendarStore.actionCommand.next(this.command);
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.eventCalendar, {
            hubName: this.hubName,
        }));
        this.displayingOn = DisplayingOn.event;
    };
    HubNavigatorComponent.prototype.showManualEvents = function (eventsType) {
        this.command.isEventCalendar = true;
        this.command.queryParams.feedId = null;
        this.command.queryParams.isManuallyCreated = true;
        this.command.queryParams.isHubCreated = null;
        if (eventsType !== 'All') {
            this.command.queryParams.isHubCreated = eventsType == 'Hub';
        }
        this.command.queryParams.isApproved = false;
        this.hubCalendarStore.actionCommand.next(this.command);
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.eventCalendar, {
            hubName: this.hubName,
        }));
        this.displayingOn = DisplayingOn.event;
    };
    HubNavigatorComponent.prototype.showManualPlaces = function (eventsType) {
        this.command.isEventCalendar = false;
        this.command.queryParams.feedId = null;
        this.command.queryParams.isManuallyCreated = true;
        this.command.queryParams.isHubCreated = null;
        this.command.queryParams.isApproved = false;
        if (eventsType !== 'All') {
            this.command.queryParams.isHubCreated = eventsType == 'Hub';
        }
        this.hubCalendarStore.actionCommand.next(this.command);
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.placeCalendar, {
            hubName: this.hubName,
        }));
        this.displayingOn = DisplayingOn.place;
    };
    HubNavigatorComponent.prototype.showPlacesByFeed = function (feedId) {
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.placeCalendar, {
            hubName: this.hubName,
        }));
        this.command.isEventCalendar = false;
        this.command.queryParams.feedId = feedId;
        this.command.queryParams.category = 'all';
        this.command.queryParams.isManuallyCreated = false;
        this.command.queryParams.isHubCreated = false;
        this.command.queryParams.search = '';
        this.hubCalendarStore.actionCommand.next(this.command);
        this.searchParam.searchText = '';
        this.displayingOn = DisplayingOn.place;
    };
    HubNavigatorComponent.prototype.showPageEvents = function (feedId) {
        this.command.isEventCalendar = true;
        this.command.queryParams.feedId = feedId;
        this.command.queryParams.category = 'All';
        this.command.queryParams.isManuallyCreated = false;
        this.command.queryParams.isHubCreated = null;
        this.command.queryParams.from = this.isFilterDateEnabled ? this.command.queryParams.from : null;
        this.command.queryParams.to = this.isFilterDateEnabled ? this.command.queryParams.to : null;
        this.hubCalendarStore.actionCommand.next(this.command);
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.eventCalendar, {
            hubName: this.hubName,
        }));
        this.displayingOn = DisplayingOn.event;
    };
    HubNavigatorComponent.prototype.showEventsByDMO = function (dmo) {
        this.command.isEventCalendar = true;
        this.command.queryParams.category = 'All';
        this.command.queryParams.isHubCreated = null;
        this.command.queryParams.isApproved = this.eventStatusSelection === 'approved';
        this.command.queryParams.from = this.isFilterDateEnabled ? this.command.queryParams.from : null;
        this.command.queryParams.to = this.isFilterDateEnabled ? this.command.queryParams.to : null;
        this.command.queryParams.dmo = dmo;
        this.hubCalendarStore.actionCommand.next(this.command);
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.eventCalendar, {
            hubName: this.hubName,
        }));
        this.displayingOn = DisplayingOn.event;
    };
    HubNavigatorComponent.prototype.feedIsSelected = function (feedId) {
        if (this.command.queryParams.feedId == null && feedId.toLowerCase() === 'all') {
            return true;
        }
        else {
            return this.command.queryParams.feedId === feedId;
        }
    };
    HubNavigatorComponent.prototype.manualEventsIsSelected = function (eventType) {
        if (!this.command.isEventCalendar) {
            return false;
        }
        if (this.command.queryParams.isHubCreated == null && eventType == 'All') {
            return true;
        }
        else {
            var isHubCreated = eventType == 'Hub';
            return this.command.queryParams.isHubCreated == isHubCreated;
        }
    };
    HubNavigatorComponent.prototype.manualPlacesIsSelected = function (eventType) {
        if (this.command.isEventCalendar) {
            return false;
        }
        if (this.command.queryParams.isHubCreated == null && eventType == 'All') {
            return true;
        }
        else {
            var isHubCreated = eventType == 'Hub';
            return this.command.queryParams.isHubCreated == isHubCreated;
        }
    };
    HubNavigatorComponent.prototype.loadLocationFeeds = function () {
        var _this = this;
        if (!this.hubLocations || !this.hubLocations.length) {
            this.isLoadingFeeds = true;
            this.hubApiService.getLocationFeeds(this.hubName).subscribe(function (data) {
                _this.hubLocations = data;
                // this.facebookLocations = data.filter(x => config.placeSocialName.any(y => y === x.socialName));
                _this.facebookLocations = _this.hubLocations.filter(function (x) { return x.socialName === (_this.toggleAndSource.dataSource.place || 'google') && x.title; });
                _this.otherLocations = data.filter(function (x) { return !config.placeSocialName.any(function (y) { return y === x.socialName; }); });
                _this.eventFeeds = !_this.toggleAndSource.toggle.eventByGeolocation
                    ? _this.hubPages
                    : _this.hubPages.concat(_this.otherLocations);
                _this.isLoadingFeeds = false;
                _this.hubFacebookLocationFeedsStore.locationCommand.next(new HubFacebookFeedsCommand(_this.hubLocations));
            });
        }
        else {
            // this.facebookLocations = this.hubLocations.filter(x => config.placeSocialName.any(y => y === x.socialName));
            this.facebookLocations = this.hubLocations.filter(function (x) { return x.socialName === (_this.toggleAndSource.dataSource.place || 'google') && x.title; });
            this.otherLocations = this.hubLocations.filter(function (x) { return !config.placeSocialName.any(function (y) { return y === x.socialName; }); });
            this.eventFeeds = !this.toggleAndSource.toggle.eventByGeolocation
                ? this.hubPages
                : this.hubPages.concat(this.otherLocations);
        }
    };
    HubNavigatorComponent.prototype.loadRegionalAccountDMOs = function () {
        var _this = this;
        if (!this.regionalAccountDMOs || !this.regionalAccountDMOs.length) {
            this.isLoadingDMOs = true;
            this.hubApiService.getRegionalAccountDMOs(this.hubName).subscribe(function (data) {
                _this.regionalAccountDMOs = data;
                _this.isLoadingDMOs = false;
            });
        }
    };
    HubNavigatorComponent.prototype.dmoIsSelected = function (dmo) {
        if (this.command.queryParams.dmo == null && dmo.toLowerCase() === 'all') {
            return true;
        }
        else {
            return this.command.queryParams.dmo === dmo;
        }
    };
    HubNavigatorComponent.prototype.placeCategoryIsSelected = function (category) {
        return this.command.queryParams.category == category && !this.command.isEventCalendar;
    };
    HubNavigatorComponent.prototype.expandPlace = function ($event) {
        if (!this.toggleAndSource.toggle.placeCalendar) {
            $event.stopPropagation();
            return;
        }
        this.showPlace($event);
    };
    HubNavigatorComponent.prototype.selectCustomDefaultPlaceCategory = function ($event) {
        console.log($event);
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.placeCalendar, {
            hubName: this.hubName,
        }));
        this.setToApprovedIfIsOnSimilarPlaces();
        this.command.isEventCalendar = false;
        this.command.queryParams.feedId = null;
        this.command.queryParams.category = $event.title;
        this.command.queryParams.categoryList = $event.categoryList;
        this.command.queryParams.isManuallyCreated = false;
        this.command.queryParams.isHubCreated = null;
        this.command.queryParams.search = '';
        this.hubCalendarStore.actionCommand.next(this.command);
        this.searchParam.searchText = '';
        this.command.queryParams.source = this.toggleAndSource.dataSource.place;
        this.displayingOn = DisplayingOn.place;
    };
    HubNavigatorComponent.prototype.clearSearchText = function (type) {
        this.searchParam.searchText = '';
        this.router.navigateByUrl(getRouteUrl(type === 'place' ? routeConfigs.hub.placeCalendar : routeConfigs.hub.eventCalendar, {
            hubName: this.hubName,
        }));
        this.command.isEventCalendar = type === 'event';
        this.command.queryParams.feedId = null;
        this.command.queryParams.category = 'All';
        this.command.queryParams.search = undefined;
        this.command.queryParams.isManuallyCreated = undefined;
        this.command.queryParams.noFilter = this.searchParam.isSearchPlaceWithNoFilter;
        //this.command.queryParams.isApproved = true;
        this.hubCalendarStore.actionCommand.next(this.command);
        this.KeywordService.updateKeyword(this.searchParam.searchText);
    };
    HubNavigatorComponent.prototype.searchFocus = function () {
        this.searchParam.isShowSearchPlaceWithNoFilter = true;
        this.searchParam.isShowFuzzySearch = true;
    };
    HubNavigatorComponent.prototype.search = function () {
        var _this = this;
        this.searchParam.isSearching = true;
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.placeCalendar, {
            hubName: this.hubName,
        }));
        this.command.isEventCalendar = false;
        this.command.queryParams.feedId = null;
        this.command.queryParams.category = 'All';
        this.command.queryParams.search = this.searchParam.searchText;
        // search all places existing in the database, ignore whether it is blocked, blacklisted or category not in allowed list
        this.command.queryParams.noFilter = this.searchParam.isSearchPlaceWithNoFilter;
        this.command.queryParams.useFuzzyQuery = this.searchParam.isFuzzySearch;
        this.command.queryParams.isManuallyCreated = undefined;
        //this.command.queryParams.isApproved = undefined;
        this.hubCalendarStore.actionCommand.next(this.command);
        this.KeywordService.updateKeyword(this.searchParam.searchText);
        setTimeout(function () {
            _this.searchParam.isSearching = false;
        }, 3000);
    };
    HubNavigatorComponent.prototype.searchEvents = function () {
        var _this = this;
        if (this.eventStatusSelection === 'similar') {
            this.eventStatusSelection = 'approved';
            this.command.queryParams.isApproved = true;
        }
        this.searchParam.isSearching = true;
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.eventCalendar, {
            hubName: this.hubName,
        }));
        this.command.isEventCalendar = true;
        this.command.queryParams.feedId = null;
        this.command.queryParams.category = 'All';
        this.command.queryParams.search = this.searchParam.searchText;
        this.command.queryParams.isManuallyCreated = undefined;
        if (!this.isOpenRegionalAccountType) {
            this.command.queryParams.dmo = null;
        }
        this.hubCalendarStore.actionCommand.next(this.command);
        setTimeout(function () {
            _this.searchParam.isSearching = false;
        }, 3000);
    };
    HubNavigatorComponent.prototype.searchPlacesWithNoFilterChange = function () {
        if (this.searchParam.searchText) {
            this.search();
        }
    };
    HubNavigatorComponent.prototype.fuzzySearchPlaces = function () {
        if (this.searchParam.searchText) {
            this.search();
        }
    };
    HubNavigatorComponent.prototype.showEditView = function () {
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.editAccount, {
            hubName: this.hubName,
        }));
        this.displayingOn = DisplayingOn.contentManagement;
        this.closeContentAccordions();
    };
    HubNavigatorComponent.prototype.showContentManagementView = function () {
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.contentManagement, {
            hubName: this.hubName,
        }));
        this.displayingOn = DisplayingOn.contentManagement;
        this.closeContentAccordions();
    };
    HubNavigatorComponent.prototype.showCustomizeStyle = function () {
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.customization, {
            hubName: this.hubName,
        }));
        this.displayingOn = DisplayingOn.design;
        this.closeContentAccordions();
    };
    HubNavigatorComponent.prototype.showMarketing = function () {
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.marketing, {
            hubName: this.hubName,
        }));
        this.displayingOn = DisplayingOn.marketing;
        this.closeContentAccordions();
    };
    HubNavigatorComponent.prototype.showUploadEvents = function () {
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.uploadEvents, {
            hubName: this.hubName,
        }));
        this.displayingOn = DisplayingOn.uploadEvents;
        this.closeContentAccordions();
    };
    HubNavigatorComponent.prototype.showTours = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.tours, {
                            hubName: this.hubName,
                        }))];
                    case 1:
                        _a.sent();
                        this.displayingOn = DisplayingOn.tripPlanner;
                        return [2 /*return*/];
                }
            });
        });
    };
    //
    // public async showGooglePlace() {
    //     await this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.googlePlace, {
    //         hubName: this.hubName
    //     }));
    // }
    HubNavigatorComponent.prototype.showPlace = function (value) {
        if (!value.target.id) {
            return;
        }
        value.target.id = value.target.id === 'All-places' ? 'All' : value.target.id;
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.placeCalendar, {
            hubName: this.hubName,
        }));
        this.command.isEventCalendar = false;
        this.command.queryParams.feedId = null;
        this.command.queryParams.category = value.target.id;
        this.command.queryParams.categoryList = null;
        this.setToApprovedIfIsOnSimilarPlaces();
        this.command.queryParams.isManuallyCreated = false;
        this.command.queryParams.isHubCreated = null;
        this.command.queryParams.search = '';
        this.hubCalendarStore.actionCommand.next(this.command);
        this.searchParam.searchText = '';
        this.command.queryParams.source = this.toggleAndSource.dataSource.place;
        this.displayingOn = DisplayingOn.place;
    };
    HubNavigatorComponent.prototype.filterEvents = function () {
        console.log('isFilterDateEnabled', this.isFilterDateEnabled);
        console.log('eventStatusSelection', this.eventStatusSelection);
        if (this.isFilterDateEnabled && this.eventStatusSelection === 'similar') {
            this.eventStatusSelection = 'approved';
        }
        // see similarEvents()
        if (this.eventStatusSelection === 'similar')
            return;
        this.command.queryParams.isApproved = this.eventStatusSelection === 'approved';
        var routeParams = { hubName: this.hubName };
        var eventCalendarUrl = getRouteUrl(routeConfigs.hub.eventCalendar, routeParams);
        if (!this.router.isActive(eventCalendarUrl, false)) {
            this.router.navigateByUrl(eventCalendarUrl);
        }
        var command = new HubCalendarActionCommand();
        command.queryParams.from = this.isFilterDateEnabled ? this.command.queryParams.from : null;
        command.queryParams.to = this.isFilterDateEnabled ? this.command.queryParams.to : null;
        command.queryParams.isApproved = this.command.queryParams.isApproved;
        command.queryParams.dmo = this.command.queryParams.dmo;
        command.isEventCalendar = true;
        command.queryParams.isManuallyCreated = undefined;
        command.queryParams.isHubCreated = undefined;
        command.queryParams.feedId = this.command.queryParams.feedId;
        this.searchParam.searchText = null;
        if (command.queryParams.from) {
            command.queryParams.from.setHours(0);
            command.queryParams.from.setMinutes(0);
            command.queryParams.from.setSeconds(0);
        }
        if (command.queryParams.to) {
            command.queryParams.to = new Date(EventTimeService.addHours(command.queryParams.to, 24));
            command.queryParams.to.setHours(0);
            command.queryParams.to.setMinutes(0);
            command.queryParams.to.setSeconds(0);
        }
        this.hubCalendarStore.actionCommand.next(command);
        this.displayingOn = DisplayingOn.event;
    };
    HubNavigatorComponent.prototype.similarEvents = function () {
        this.eventStatusSelection = 'similar';
        this.isFilterDateEnabled = false;
        this.command.queryParams.search = undefined;
        var routeParams = { hubName: this.hubName, type: 'normal' };
        var similarEventCalendarUrl = getRouteUrl(routeConfigs.hub.similarEventCalendar, routeParams);
        // if (!this.router.isActive(similarEventCalendarUrl, false))
        this.router.navigateByUrl(similarEventCalendarUrl);
    };
    HubNavigatorComponent.prototype.similarPlaces = function () {
        this.placeLocationAccordion && this.placeLocationAccordion.isFiltering && this.placeLocationAccordion.clearFilter();
        // this.placeSourceAccordion && this.placeSourceAccordion.isFiltering && this.placeSourceAccordion.clearFilter();
        this.customDefaultPlaceCategoryAccordion && this.customDefaultPlaceCategoryAccordion.clearFilter();
        this.command.queryParams.search = undefined;
        // this.command.queryParams.isNewlyPulled = undefined;
        this.command.queryParams.category = undefined;
        this.command.queryParams.categoryList = undefined;
        this.command.queryParams.isManuallyCreated = undefined;
        this.command.queryParams.feedId = undefined;
        this.command.queryParams.isApproved = undefined;
        this.searchParam.searchText = '';
        var routeParams = { hubName: this.hubName };
        var similarPlaceCalendarUrl = getRouteUrl(routeConfigs.hub.similarPlaceCalendar, routeParams);
        this.router.navigateByUrl(similarPlaceCalendarUrl);
    };
    HubNavigatorComponent.prototype.filterPlaces = function (isApprovedAction) {
        var routeParams = { hubName: this.hubName };
        var placeCalendarUrl = getRouteUrl(routeConfigs.hub.placeCalendar, routeParams);
        if (!this.router.isActive(placeCalendarUrl, false)) {
            this.router.navigateByUrl(placeCalendarUrl);
        }
        var command = new HubCalendarActionCommand();
        command.queryParams.isApproved = this.command.queryParams.isApproved;
        command.queryParams.category = this.command.queryParams.category;
        command.isEventCalendar = false;
        command.queryParams.isManuallyCreated = undefined;
        command.queryParams.isHubCreated = undefined;
        command.queryParams.source = this.toggleAndSource.dataSource.place;
        //if (isApprovedAction) {
        command.queryParams.feedId = this.command.queryParams.feedId;
        command.queryParams.search = null;
        this.searchParam.searchText = null;
        //}
        if (command.queryParams.from) {
            var fromDate = new Date(command.queryParams.from);
            fromDate.setHours(0);
            fromDate.setMinutes(0);
            fromDate.setSeconds(0);
            command.queryParams.from = fromDate;
        }
        if (command.queryParams.to) {
            var toDate = new Date(command.queryParams.to);
            toDate.setHours(0);
            toDate.setMinutes(0);
            toDate.setSeconds(0);
            command.queryParams.to = toDate;
        }
        // show all places when selecting unapproved
        this.searchParam.isSearchPlaceWithNoFilter = !this.command.queryParams.isApproved;
        command.queryParams.noFilter = !this.command.queryParams.isApproved;
        this.hubCalendarStore.actionCommand.next(command);
        this.displayingOn = DisplayingOn.place;
    };
    HubNavigatorComponent.prototype.closeContentAccordions = function () {
        this.eventAccordion.close();
        this.placeAccordion.close();
        this.manualAccordion.close();
    };
    Object.defineProperty(HubNavigatorComponent.prototype, "isAllPlaceCategoriesTurnedOff", {
        get: function () {
            return PlaceService.isAllCategoriesTurnedOff(this.toggleAndSource.toggle.placeCategory);
        },
        enumerable: true,
        configurable: true
    });
    HubNavigatorComponent.prototype.setToApprovedIfIsOnSimilarPlaces = function () {
        // this.command.queryParams.isApproved is null or undefined means now showing similar places, so remove the radio button selection
        this.command.queryParams.isApproved = isNullOrUndefined(this.command.queryParams.isApproved)
            ? true
            : this.command.queryParams.isApproved;
    };
    return HubNavigatorComponent;
}(BaseComponent));
export { HubNavigatorComponent };
export var DisplayingOn;
(function (DisplayingOn) {
    DisplayingOn[DisplayingOn["event"] = 0] = "event";
    DisplayingOn[DisplayingOn["place"] = 1] = "place";
    DisplayingOn[DisplayingOn["manualEntry"] = 2] = "manualEntry";
    DisplayingOn[DisplayingOn["tripPlanner"] = 3] = "tripPlanner";
    DisplayingOn[DisplayingOn["contentManagement"] = 4] = "contentManagement";
    DisplayingOn[DisplayingOn["design"] = 5] = "design";
    DisplayingOn[DisplayingOn["marketing"] = 6] = "marketing";
    DisplayingOn[DisplayingOn["uploadEvents"] = 7] = "uploadEvents";
    DisplayingOn[DisplayingOn["googlePlace"] = 8] = "googlePlace";
})(DisplayingOn || (DisplayingOn = {}));



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/side.bar/hub.side.bar.component.ts.pre-build-optimizer.js